/**
 * Configuration de l'URL de l'API
 * En production, utilise l'URL relative (même serveur)
 * En développement, utilise localhost
 */

const getApiUrl = () => {
  // Si REACT_APP_API_URL est défini, l'utiliser
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // En production (build), utiliser l'URL relative
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  // En développement, utiliser localhost
  return 'http://localhost:5001/api';
};

export const API_URL = getApiUrl();

// Pour les composants qui ont besoin de l'URL complète avec le chemin
export const getApiEndpoint = (endpoint) => {
  // Si l'URL commence par /, c'est déjà relatif
  if (endpoint.startsWith('/')) {
    return `${API_URL}${endpoint}`;
  }
  return `${API_URL}/${endpoint}`;
};

export default API_URL;

